import { createSlice } from '@reduxjs/toolkit'

export const citiesSlice = createSlice({
  name: 'cities',
  initialState: [],
  reducers: {
    updateCities: (state, action) => {
      return action.payload;
    },
  },
})

export const { updateCities } = citiesSlice.actions

export default citiesSlice.reducer
